<mat-form-field appearance="outline" class="w-[250px]">
  <mat-label>Cost Center</mat-label>
  <input type="text" inputmode="decimal" matInput [formControl]="costCenterCtrl" />

  <mat-hint notranslate>{{ costCenterDescription }}</mat-hint>
  @if (costCenterCtrl.getError('invalid')) {
    <mat-error> Must be 6 numbers </mat-error>
  }
  @if (costCenterCtrl.getError('noCostCenter')) {
    <mat-error> No cost center {{ costCenterCtrl.value }} </mat-error>
  }

  <button
    mat-icon-button
    matSuffix
    aria-label="Find A Cost Center"
    title="Find a cost center"
    id="LogRocket-ContractSelect-CostCenterSearch-MagnifyingGlass"
    (click)="openCostCenterSearchModal()"
  >
    <mat-icon>search</mat-icon>
  </button>
</mat-form-field>
